// extracted by mini-css-extract-plugin
export default {"closeButton":"CloseMedia_closeButton__b0+7J"};